import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header pb-0 border-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "btn btn-sm btn-icon btn-active-color-primary pull-end" }
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = {
  key: 0,
  class: "modal-body scroll-y mx-5 mx-xl-15 pt-0"
}
const _hoisted_8 = {
  key: 2,
  class: "modal-footer flex-center"
}

import { hideModal } from "@/core/helpers/dom";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    id: { default: "modal" },
    title: { default: undefined },
    customClass: { default: "mw-650px" },
    unwrapped: { type: Boolean, default: false }
  },
  emits: ["hide"],
  setup(__props: any, { emit: __emit }) {

const props = __props;



const emit = __emit;

const hide = () => {
    hideModal(props.id);
    emit("hide");
};

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    id: props.id
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`modal-dialog ${_ctx.customClass}`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              onClick: _withModifiers(hide, ["stop"])
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ])
        ]),
        (!_ctx.unwrapped)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _renderSlot(_ctx.$slots, "default", { key: 1 }),
        (_ctx.$slots.footer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "footer")
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})